import ReactDom from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/Home';
import Contact from './pages/Contact';
import NoPage from './pages/NoPage';

import Login from './pages/Login';
import Register from './pages/Register';

import Profile from './pages/Profile'
import Settings from './pages/Settings';
import Search from './pages/Search';

import EmployerProfile from './pages/EmployerProfile';
import HouseManagerProfile from './pages/HouseManageProfile';

import FindHouseGirl from './pages/FindHouseGirl';
import ContractNotification from './pages/Notifications';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout/>}>
          <Route index element={<Home/>} />
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path='/register' element={<Register/>}/>
          <Route path='/profile/' element={<Profile/>}/>
          <Route path='/settings' element={<Settings/>}/>
          <Route path='/search' element={<Search/>}/>
          <Route path='/findhousegirl/' element={<FindHouseGirl/>}/>
          <Route path="/profile/house_manager/:id" element={<HouseManagerProfile />} />
          <Route path='/profile/employer/:id' element={<EmployerProfile/>}/>
          <Route path='/notifications/' element={<ContractNotification/>}/>
          <Route path='*' element={<NoPage/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDom.createRoot(document.getElementById('root'))
root.render(<App/>)